(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-registration"] && !Shopify.designMode) return;
  try {
    
  const methodSelect = document.getElementById('contact_method');
  const brochureFields = document.querySelectorAll('.contact-reg__brochure-field');

  if (methodSelect) {
    methodSelect.addEventListener('change', function() {
      const val = this.value;
      const show = val === 'Paper Brochure' || val.includes('Hybrid');
      brochureFields.forEach(function(field) {
        field.style.display = show ? '' : 'none';
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuToggle = document.querySelector('.header__menu-toggle');
  const menuClose = document.querySelector('.header__menu-close');
  const mobileMenu = document.querySelector('.header__mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });

    const closeMenu = () => {
      mobileMenu.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    if (menuClose) menuClose.addEventListener('click', closeMenu);
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu) closeMenu();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  const slider = document.querySelector('[data-testimonial-slider]');
  if (slider) {
    const track = slider.querySelector('[data-testimonial-track]');
    const slides = track.children;
    const prevBtn = slider.querySelector('[data-testimonial-prev]');
    const nextBtn = slider.querySelector('[data-testimonial-next]');
    const dots = slider.querySelectorAll('[data-testimonial-dot]');
    let current = 0;
    const total = slides.length;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('testimonials__dot--active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.getAttribute('data-testimonial-dot')));
      });
    });

    /* Touch/swipe support for mobile */
    let startX = 0;
    let isDragging = false;
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
      isDragging = false;
    }, { passive: true });
  }

  } catch(e) { console.error(e); }
})();
})();
